import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { toast, Toaster as ReactToaster } from "react-hot-toast";
import classNames from "classnames";
import { UiCheckCircleIcon } from "@jti/brand-icons/ui-check-circle";
import { UiWarningSolidIcon } from "@jti/brand-icons/ui-warning-solid";
import { isServerSide } from "@jti/fe-common";
import styles from "./Toaster.module.scss";
export { toast };
const global = isServerSide()
    ? { __reactHotToastToasterRendered: false }
    : window;
export const Toaster = ({ duration = 5000 }) => {
    const [shouldRender, setShouldRender] = useState(false);
    useEffect(() => {
        if (global.__reactHotToastToasterRendered) {
            return;
        }
        global.__reactHotToastToasterRendered = true;
        setShouldRender(true);
        // Clean up is needed for next.js as it doesn't reload the page,
        // but often rerenders all the components inside the page,
        // so window.__reactHotToastToasterRendered is true,
        // even though there is no Toaster element on the page
        return () => {
            global.__reactHotToastToasterRendered = false;
        };
    }, []);
    if (!shouldRender) {
        return null;
    }
    return (_jsx(ReactToaster, { toastOptions: {
            duration,
            error: {
                icon: _jsx(UiWarningSolidIcon, { className: styles.icon }),
                className: classNames(styles.toast, styles.error),
            },
            success: {
                icon: _jsx(UiCheckCircleIcon, { className: styles.icon }),
                className: classNames(styles.toast, styles.success),
            },
        } }));
};
//# sourceMappingURL=Toaster.js.map